import React, { useContext, useEffect, useState } from 'react'
import apiClient from '../api'
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react'
import { MessageFormat } from '@paypalcorp/worldready'
import { BodyText, LoadingSpinner, WarningIcon } from '@paypalcorp/pp-react'
import { extractTokenAndMerchantUrlFromUrl, removeHeaderFooter } from './utils'
import fpti from '../instrumentation'

const SaveUserDetails = () => {
  const worldReady = useContext(WorldReadyContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    removeHeaderFooter(document)
    setLoading(true)
    const { token, merchantUrl } = extractTokenAndMerchantUrlFromUrl(window)
    apiClient.get(`/getMerchantDetails?token=${token}`)
             .then((response) => {
              if (isValidUrl(merchantUrl)) {
                if(validateMerchantNameWithUrl(response.data.returnUrl, merchantUrl)) {
                  apiClient.post(`/saveUserDetailsinSession?token=${token}&merchantUrl=${merchantUrl}`)
                           .then((_response) => {
                              const merchantUrlExtracted = new URL(merchantUrl)
                              merchantUrlExtracted.searchParams.append('token', token)
                              window.location.href = merchantUrlExtracted
                              return null
                            })
                            .catch((e) => {
                              fpti.logFPTIError(
                                e,
                                `Save user details error  ${e.error.error_code}:${e.error.error_message}`,
                                e,
                              )
                              setLoading(false)
                              const errorMessage = `${new MessageFormat(worldReady, {
                                id: `authLogin.${e.message}`,
                              }).format()} ${e.error.error_code}`
                              setError(errorMessage)
                            })
                } else {
                  setLoading(false)
                  const errorMessage = `${new MessageFormat(worldReady, {
                    id: 'invalidMerchantUrl',
                  }).format()} ${merchantUrl}`
                  setError(errorMessage)
                }
              } else {
                setLoading(false)
                const errorMessage = `${new MessageFormat(worldReady, {
                  id: 'invalidUrl',
                }).format()} ${merchantUrl}`
                setError(errorMessage)
              }
             })
             .catch((e) => {
              fpti.logFPTIError(
                e,
                `Getting merchant details error ${e.error.error_code}:${e.error.error_message}`,
                e,
              )
              setLoading(false)
              const errorMessage = `${new MessageFormat(worldReady, {
                id: `authLogin.${e.message}`,
              }).format()} ${e.error.error_code}`
              setError(errorMessage)
            });
  }, [worldReady])

  function isValidUrl(inputUrl) {
    let url;
    try {
      url = new URL(inputUrl);
    } catch {
      return false;
    }
    return url.protocol === 'http:' || url.protocol === 'https:';
  }

  function validateMerchantNameWithUrl(returnURL, merchantUrl) {
    const returnUrlObject = new URL(returnURL);
    const merchantUrlObject = new URL(merchantUrl);
    const wwwRegex = /www\./;
    const returnHostname = returnUrlObject.hostname.replace(wwwRegex, '');
    const merchantHostname = merchantUrlObject.hostname.replace(wwwRegex, '');
    return returnHostname.toLowerCase() === merchantHostname.toLowerCase();
  }

  if (error) {
    return (
      <div className="aa_alertIndex_parent" id="aa_saveUser_error">
        <WarningIcon size="xl" color="sysColorErrorMain" />
        <BodyText className="aa_errorText" type="error">
          {error}
        </BodyText>
      </div>
    )
  }

  if (loading) {
    return (
      <div className="aa_rootLoading">
        <LoadingSpinner size="xl" />
      </div>
    )
  }
  return <div />
}
export default SaveUserDetails
